import React from 'react';

const MASSE = {
  gross: { kreis: 64, schrift: 42, abstand: 10 },
  klein: { kreis: 32, schrift: 21, abstand: 5 },
};

// Boot (weiß gefärbt) + „TimeNYzer“ in Montserrat; Schrifthöhe ≈ 46 % des Kreises wie beim PersoNYzer-Logo.
export const TimeNYzerWortmarke = ({ groesse = 'gross', testid }) => {
  const m = MASSE[groesse];
  return (
    <div role="img" aria-label="TimeNYzer" className="inline-flex items-center" style={{ gap: m.abstand }} data-testid={testid}>
      <img src="/anmeldung/boot.png" alt="" aria-hidden="true" width={m.kreis} height={m.kreis}
        style={{ width: m.kreis, height: m.kreis, filter: 'brightness(0) invert(1)' }} />
      <span aria-hidden="true" style={{ fontFamily: "'Montserrat', sans-serif", fontSize: m.schrift, fontWeight: 400, lineHeight: 1, color: '#fff' }}>
        Time<span style={{ fontWeight: 700 }}>NY</span>zer
      </span>
    </div>
  );
};

export default TimeNYzerWortmarke;
